import React, { useEffect } from "react";

const ProyectPageSelector = (props) => {
  return (
    <div className=" w-100">
    <div className="page-menu-select mx-auto">
    {props.pages &&
      props.pages.map((page, idx) => (
       
        <button className={`page-select-button `} key={idx} onClick={() => props.setPage(idx)} type="button">
          {page.title}
         
        </button>
      ))}
    </div>
    </div>
  );
};

export default ProyectPageSelector;
